"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _bodyColumn = _interopRequireDefault(require("../../columns/body-column"));
var _descriptionDrawer = _interopRequireDefault(require("../../common/description-drawer"));
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const BodyContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BodyContainer",
  class: "pl-bejvl7y"
});
const Row = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Row",
  class: "pl-r1x784d1"
});
const CategoryColumn = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CategoryColumn",
  class: "pl-c97d490"
});
const FeaturedColumn = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FeaturedColumn",
  class: "pl-f1tiq9jh",
  vars: {
    "f1tiq9jh-0": [({
      hasDescription
    }) => hasDescription ? `${_intents.default.ux.navigateHovered.foregroundColor}` : 'initial']
  }
});
const SecondColumn = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SecondColumn",
  class: "pl-skjw6bn"
});
const DescriptionRow = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DescriptionRow",
  class: "pl-d1q058d2"
});

/**
 * BodyRowMobile Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Array of column items
 * @param {String} props.rowGroupTitle Row Group name
 * @param {String} props.featuredColumnText Featured Column name
 * @param {String} props.descriptionText Row description text
 * @param {Number} props.toggleState Nav toggle state
 * @returns {React.ReactElement} BodyRowMobile Component
 * @public
 */

function BodyRowMobile({
  items,
  rowGroupTitle,
  featuredColumnText,
  descriptionText,
  toggleState
}) {
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const [height, setHeight] = (0, _react.useState)('0px');
  const ref = (0, _react.useRef)(null);
  function toggleDescription({
    key
  }) {
    if (key === 'Enter') {
      setExpanded(!expanded);
      setHeight(expanded ? '0px' : `${ref.current.scrollHeight}px`);
    }
    setExpanded(!expanded);
    setHeight(expanded ? '0px' : `${ref.current.scrollHeight}px`);
  }
  const filteredItems = items?.filter(event => event);
  const filteredIndex = toggleState >= 0 && toggleState - 1 < filteredItems?.length ? toggleState - 1 : 0;
  return /*#__PURE__*/_react.default.createElement(BodyContainer, {
    role: "row"
  }, rowGroupTitle && /*#__PURE__*/_react.default.createElement(Row, null, /*#__PURE__*/_react.default.createElement(CategoryColumn, {
    role: "cell",
    "data-cy": "mobile-category-title"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    text: rowGroupTitle
  })), /*#__PURE__*/_react.default.createElement(SecondColumn, {
    role: "cell"
  })), /*#__PURE__*/_react.default.createElement(Row, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FeaturedColumn, (0, _extends2.default)({
    onClick: descriptionText && toggleDescription,
    "data-cy": "mobile-row-title",
    tabIndex: "0",
    "data-focus": "key",
    role: "cell",
    hasDescription: !!descriptionText
  }, _patternLibraryUtils.tracking.create(featuredColumnText, true, false)), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: featuredColumnText
  }))), /*#__PURE__*/_react.default.createElement(SecondColumn, {
    role: "cell"
  }, filteredItems?.slice(filteredIndex, filteredIndex + 1)?.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_bodyColumn.default, item));
  }))), descriptionText && /*#__PURE__*/_react.default.createElement(DescriptionRow, {
    "data-cy": "mobile-description-row"
  }, /*#__PURE__*/_react.default.createElement(_descriptionDrawer.default, {
    forwardedRef: ref,
    style: {
      maxHeight: `${height}`,
      opacity: `${expanded ? 1 : 0}`
    },
    descriptionText: descriptionText,
    isMobile: true
  })));
}
var _default = exports.default = BodyRowMobile;
BodyRowMobile.propTypes = {
  items: _propTypes.default.array,
  rowGroupTitle: _propTypes.default.string,
  featuredColumnText: _propTypes.default.string,
  descriptionText: _propTypes.default.string,
  toggleState: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};